import SharedDialog from '../../../../../../global/Modal/Modal';
import { SaveColumnsModalProps } from '../types';

export function SaveColumnsModal({
  isOpen,
  onClose,
  onConfirm,
  columnSelectionName,
  setColumnSelectionName,
  columnDataToSave,
  isSaving,
}: SaveColumnsModalProps) {
  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Save Column Selection"
      description="Give your column selection a name to save it for later use."
      confirmText={isSaving ? 'Saving...' : 'Save'}
      cancelText="Cancel"
      onConfirm={onConfirm}
      data-testid="save-columns-modal"
      hasConfirmBtn
    >
      <div className="mt-4">
        <div className="mb-3">
          <label htmlFor="columnSelectionName" className="form-label font-medium">
            Column Selection Name:
          </label>
          <input
            id="columnSelectionName"
            type="text"
            className="form-control"
            value={columnSelectionName}
            onChange={e => setColumnSelectionName(e.target.value)}
            placeholder="Enter a name for this column selection"
            maxLength={100}
            disabled={isSaving}
          />
          {!columnSelectionName.trim() && (
            <small className="text-danger">Please enter a name for the column selection</small>
          )}
        </div>

        {columnDataToSave && (
          <div className="mt-3">
            <h6 className="font-medium mb-2">Selection Details:</h6>
            <div className="bg-light p-3 rounded">
              <div className="row">
                <div className="col-md-12">
                  <small className="text-muted">View:</small> <strong>{columnDataToSave.view}</strong>
                  <br />
                  <small className="text-muted">Tab:</small> <strong>{columnDataToSave.tab}</strong>
                  <br />
                  <small className="text-muted">Type:</small>{' '}
                  <strong>{columnDataToSave.isEvidence ? 'Evidence' : 'Summary'}</strong>
                  {columnDataToSave.searchItems && columnDataToSave.searchItems.length > 0 && (
                    <>
                      <br />
                      <small className="text-muted">Search Items:</small>{' '}
                      <strong>
                        {columnDataToSave.searchItems.map(item => item.name || item.id).join(', ')}
                      </strong>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-2">
                <small className="text-muted">Visible Columns:</small>
                <br />
                <small>
                  {Object.entries(columnDataToSave.columnVisibilityModel || {})
                    .filter(([_, visible]) => visible)
                    .map(([col]) => col)
                    .join(', ')}
                </small>
              </div>
            </div>
          </div>
        )}
      </div>
    </SharedDialog>
  );
}
